"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SITE_CONFIG_UPDATE_INTERVAL = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contexts = require("../../config/contexts");
var _getDateTime = require("../../utils/getDateTime");
var _object = require("../../utils/type-checks/object");
var _getSiteConfig = require("../../utils/getSiteConfig");
var _useInterval = require("../../utils/hooks/useInterval");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SITE_CONFIG_UPDATE_INTERVAL = exports.SITE_CONFIG_UPDATE_INTERVAL = 300000;

/**
	 * Context provider for site configuration settings
	 *
	 * @visibleName Site Config Manager
	 * @author Eric Shoemaker
	*/
const SiteConfigManager = props => {
  const {
    children,
    config
  } = props;
  const [siteConfig, setSiteConfig] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    (0, _object.isObject)(config) && setSiteConfig(config);
  }, [config]);
  (0, _useInterval.useInterval)(() => {
    (0, _getDateTime.getDateTime)(siteConfig.dateTimeSrc).then(currentDateTime => {
      setSiteConfig(current => ({
        ...current,
        maintenance: (0, _getSiteConfig.normalizeMaintConfig)(current.maintenance, currentDateTime)
      }));
    });
  }, SITE_CONFIG_UPDATE_INTERVAL);
  return /*#__PURE__*/_react.default.createElement(_contexts.SiteConfigContext.Provider, {
    value: siteConfig
  }, children);
};

// Define propTypes;
SiteConfigManager.propTypes = {
  /** Child node to be output */
  children: _propTypes.default.node,
  /** Configuration object */
  config: _propTypes.default.object.isRequired
};

// Export component as default;
var _default = exports.default = SiteConfigManager;